import PropTypes from 'prop-types';
import React from 'react';
import Col from 'react-bootstrap/lib/Col';
import Row from 'react-bootstrap/lib/Row';

import OrderTrip from '../../records/order/Trip';

import FareShort from './FareShort';
import SeasonFareShort from './SeasonFareShort';
import BaseModal from '../general/BaseModal';


function RemoveJourneyModal ({ onBack, onConfirm, journey }) {
    const modalProps = {
        titleText: 'order.summary.confirmRemoveJourney',
        closeText: 'button.text.cancel',
        continueText: 'button.text.removeJourney',
        onClose: onBack,
        onContinue: onConfirm,
        className: 'modal--sm modal--remove-journey'
    };

    return (
        <BaseModal { ...modalProps }>
            <Row>
                <Col sm={ 12 }>
                     <ul className="order-summary__list list-unstyled">
                        { journey.getJourneyFares().map((fare, key) => {
                            if (journey.hasSeasonFare()) { return <SeasonFareShort orderFare={ fare } key={ key } open />; }
                            return <FareShort orderFare={ fare } key={ key } open />;
                        }) }
                    </ul>
                </Col>
            </Row>
        </BaseModal>
    );
}


RemoveJourneyModal.propTypes = {
    journey: PropTypes.instanceOf(OrderTrip).isRequired,
    onBack: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired
};


export default RemoveJourneyModal;
